// Helperfunctions for ALTN filter

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import '../../style/map.scss';
import { fetchTAFV2, fetchMETAR, getNOTAMListFromAllData } from '../helperfunctions';
import { formatLongLat } from './mapHelperFunctions';
import { getTankeringFuelKg } from '../../helpers/calculateReqFuel';

// adds markers of all alternate airports (used in ALTN filter)
export function addAltAirports(
  map,
  data,
  markerList,
  reqFuel,
  handleOpenAirportModal,
) {
  for (
    let i = 0;
    i < (data?.AltRoute_List?.[0]?.AlternateRoute || []).length;
    i++
  ) {
    const altAirportIndex =
      (data.AltRoute_List[0].AlternateRoute[i]?.AltWP_List?.[0]?.WayPoint || [])
        .length - 1 || 0;
    const altAirportName =
      data.AltRoute_List[0].AlternateRoute[i]?.AltWP_List?.[0]?.WayPoint[
        altAirportIndex
      ]?.sWaypointLongName;
    const altAirportICAO = data.AltRoute_List[0].AlternateRoute[i]?.sICAO;
    const altAirportLong = formatLongLat(
      data.AltRoute_List[0].AlternateRoute[i]?.AltWP_List?.[0]?.WayPoint?.[
        altAirportIndex
      ]?.nLon
    );
    const altAirportLat = formatLongLat(
      data.AltRoute_List[0].AlternateRoute[i]?.AltWP_List?.[0]?.WayPoint[
        altAirportIndex
      ]?.nLat
    );
    const notamList = getNOTAMListFromAllData(data);
    let altAirportTAF;
    let altAirportMETAR;
    let altAirportFlightCategory;

    // fetching taf data (using V2 endpoint with JSON format)
    fetchTAFV2(altAirportICAO)
      .then((res) => res.json())
      .then(
        (res) =>
        (altAirportTAF = res?.[0]?.rawTAF
          ? res[0].rawTAF
          : 'TAF data not found')
      );

    // fetching metar data
    fetchMETAR(altAirportICAO)
      .then((res) => res.json())
      .then((res) => {
        altAirportMETAR = res?.[0]?.METAR?.[0];
        altAirportFlightCategory = res?.[0]?.METAR?.[0]?.flight_category?.[0]
          ? res[0].METAR[0].flight_category[0]
          : 'Flight category data not found';

        const markerElement = document.createElement('div');
        const enoughFuel =
          (reqFuel || 0) * 1000 + getTankeringFuelKg(data) >
          (data?.nBlockFuel_KG || 0) -
          (data?.Alt_List?.[0]?.Alternate?.[0]?.nAlternateFuel_KG || 0) +
          (+data?.Alt_List?.[0]?.Alternate?.[i]?.nAlternateFuel_KG || 0);

        // If enough fuel to reach alternate -> marker should be green otherwise grey
        // The color of the airplane icon inside of the marker is dependent on the flight category which is fetched from the metar data
        if (enoughFuel && altAirportFlightCategory === 'LIFR') {
          markerElement.className = 'marker-green-magenta';
        } else if (enoughFuel && altAirportFlightCategory === 'IFR') {
          markerElement.className = 'marker-green-red';
        } else if (enoughFuel && altAirportFlightCategory === 'MVFR') {
          markerElement.className = 'marker-green-blue';
        } else if (enoughFuel && altAirportFlightCategory === 'VFR') {
          markerElement.className = 'marker-green';
        } else if (
          enoughFuel &&
          (altAirportFlightCategory === null ||
            altAirportFlightCategory === undefined)
        ) {
          markerElement.className = 'marker-green-brown';
        } else if (!enoughFuel && altAirportFlightCategory === 'LIFR') {
          markerElement.className = 'marker-grey-magenta';
        } else if (!enoughFuel && altAirportFlightCategory === 'IFR') {
          markerElement.className = 'marker-grey-red';
        } else if (!enoughFuel && altAirportFlightCategory === 'MVFR') {
          markerElement.className = 'marker-grey-blue';
        } else if (!enoughFuel && altAirportFlightCategory === 'VFR') {
          markerElement.className = 'marker-grey-green';
        } else if (
          !enoughFuel &&
          (altAirportFlightCategory === null ||
            altAirportFlightCategory === undefined)
        ) {
          markerElement.className = 'marker-grey-brown';
        }

        // add marker to map
        const marker = new mapboxgl.Marker(markerElement)
          .setLngLat([altAirportLong, altAirportLat])
          .addTo(map.current);
        markerElement.onclick = () =>
          handleOpenAirportModal(
            altAirportName,
            data?.AltRoute_List?.[0]?.AlternateRoute?.[i]?.sIATA || 'N/A',
            altAirportMETAR,
            altAirportTAF,
            altAirportICAO,
            notamList
          );

        markerList.push(marker);
      });
  }
}
